<template>
  <div class="c-filter">
    <ElForm label-width="50" inline class="elementui-common-form-styles" v-highlight>
      <ElFormItem>
        <ElInput
          ref="searchInputRef"
          v-model="formFields.keyword"
          :placeholder="searchBoxPlaceholder"
          style="width: 220px"
          clearable
          @clear="clearSearchInput"
          @focus="showScriptMatchModal"
          @keyup.enter.native="sendEvent"
        >
          <ElSelect v-model="formFields.searchType" @change="onSearchTypeChange" slot="prepend" style="width: 80px">
            <ElOption v-for="label in SEARCH_LABEL_LIST" :key="label.value" :value="label.value" :label="label.label"></ElOption>
          </ElSelect>
          <i slot="append" @click="sendEvent" class="el-icon-search"></i>
        </ElInput>
      </ElFormItem>
      <ElFormItem label="游戏">
        <el-tooltip :open-delay="1100" :disabled="!gameCheckedNodes || !gameCheckedNodes.length" effect="dark" placement="top">
          <template #content>
            <p style="max-width: 370px">
              <span v-for="(label, index) in gameCheckedNodes" :key="index"> <em v-if="index > 0">、</em>{{ label }}</span>
            </p>
          </template>
          <el-cascader
            ref="gameCascaderRef"
            clearable
            filterable
            v-model="formFields.gameIds"
            collapse-tags
            placeholder="请选择游戏"
            style="width: 220px"
            :show-all-levels="false"
            :props="{ label: 'gameName', value: 'gameId', multiple: true }"
            :options="groupGames"
            @change="onCascaderChange($event, gameCascaderRef.getCheckedNodes(), 'gameCheckedNodes')"
          >
          </el-cascader>
        </el-tooltip>
      </ElFormItem>
      <ElFormItem label="设计师">
        <ThrottleSelector
          style="width: 180px"
          v-model="formFields.designerIds"
          :list="sysUsers"
          multiple
          collapse-tags
          filterable
          clearable
          placeholder="选择设计师"
        />
      </ElFormItem>
      <ElFormItem label="策划师">
        <ThrottleSelector
          style="width: 180px"
          v-model="formFields.plannerIds"
          :list="sysUsers"
          multiple
          collapse-tags
          filterable
          clearable
          placeholder="选择策划师"
        />
      </ElFormItem>
      <ElFormItem label="标签组">
        <el-select v-model="formFields.tagGroups" filterable clearable multiple collapse-tags style="width: 180px" placeholder="选择标签组">
          <el-option v-for="item in sysTagGroups" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
      </ElFormItem>
      <ElFormItem label="AI标签">
        <el-tooltip :open-delay="1500" :disabled="!aiLabelCheckedNodes || !aiLabelCheckedNodes.length" effect="dark" placement="top">
          <template #content>
            <p style="max-width: 370px">
              <span v-for="(label, index) in aiLabelCheckedNodes" :key="index"> <em v-if="index > 0">、</em>{{ label }}</span>
            </p>
          </template>
          <el-cascader
            ref="aiLabelCascaderRef"
            clearable
            filterable
            v-model="formFields.aiLabelIds"
            collapse-tags
            placeholder="请选择AI标签"
            style="width: 200px"
            :props="{ label: 'content', value: 'labelId', multiple: true }"
            :options="aiLabelList"
            @change="onCascaderChange($event, aiLabelCascaderRef.getCheckedNodes(), 'aiLabelCheckedNodes', true)"
          >
          </el-cascader>
        </el-tooltip>
      </ElFormItem>
      <ElFormItem label="内容标签">
        <ThrottleSelector
          style="width: 200px"
          v-model="formFields.labelIds"
          :list="labelList.contentLabels"
          multiple
          collapse-tags
          filterable
          clearable
          placeholder="选择内容标签"
        />
      </ElFormItem>

      <ElFormItem label="大小">
        <el-select
          style="width: 170px"
          v-model="formFields.mult_sizeRange"
          multiple
          collapse-tags
          filterable
          clearable
          placeholder="选择大小"
        >
          <el-option v-for="item in size_data" :key="item.key" :value="item.key" :label="item.label"></el-option>
        </el-select>
      </ElFormItem>
      <ElFormItem label="尺寸">
        <el-select
          style="width: 170px"
          v-model="formFields.mult_dimension"
          multiple
          collapse-tags
          filterable
          clearable
          placeholder="选择尺寸"
        >
          <el-option v-for="item in dimension_data" :key="item.key" :value="item.key" :label="item.label"></el-option>
        </el-select>
      </ElFormItem>
      <ElFormItem label="限制媒体">
        <el-select
          style="width: 170px"
          v-model="formFields.mult_limit_media"
          multiple
          collapse-tags
          filterable
          clearable
          placeholder="选择限制媒体"
        >
          <el-option v-for="item in promote_media" :key="item.key" :value="item.value" :label="item.label"></el-option>
        </el-select>
      </ElFormItem>
      <ElFormItem label="素材样式">
        <el-cascader
          v-model="formFields.mult_image_styles"
          clearable
          filterable
          collapse-tags
          style="width: 200px"
          :props="{ label: 'content', value: 'labelId', multiple: true }"
          :options="imageStyleTagList"
        >
        </el-cascader>
      </ElFormItem>
      <ElFormItem label="头条评估标签">
        <el-select
          style="width: 200px"
          v-model="formFields.mult_toutiao_label"
          multiple
          collapse-tags
          filterable
          clearable
          placeholder="头条评估标签"
        >
          <el-option v-for="item in toutiao_label" :key="item.key" :value="item.value" :label="item.label"></el-option>
        </el-select>
      </ElFormItem>

      <ElFormItem label="3D视频源">
        <el-select
          style="width: 180px"
          v-model="formFields.videoLabelIds"
          multiple
          collapse-tags
          filterable
          clearable
          placeholder="3D视频源"
        >
          <el-option v-for="label in labelList.threeDLabels" :key="label.id" :value="label.id" :label="label.name"></el-option>
        </el-select>
      </ElFormItem>

      <ElFormItem label="元视频源">
        <ThrottleSelector
          style="width: 180px"
          v-model="formFields.originImageIdList"
          selkey="imageId"
          sellabel="imageName"
          multiple
          collapse-tags
          :list="metaSources"
          placeholder="元视频源"
          filterable
          clearable
        />
      </ElFormItem>

      <ElFormItem label="来源">
        <ElSelect v-model="formFields.source" clearable style="width: 100px" placeholder="来源">
          <ElOption v-for="item in SOURCE_TYPES" :key="item.value" :value="item.value" :label="item.label"></ElOption>
        </ElSelect>
      </ElFormItem>

      <ElFormItem label="内审理由">
        <ElSelect
          v-model="formFields.rejectReasonIds"
          style="width: 180px"
          clearable
          collapse-tags
          multiple
          filterable
          placeholder="选择审核拒绝理由"
        >
          <ElOption v-for="item in REJECT_REASONS" :value="item.value" :key="item.value" :label="item.label"></ElOption>
        </ElSelect>
      </ElFormItem>

      <ElFormItem label="消耗情况">
        <el-cascader
          ref="hasAmountRef"
          v-model="formFields.amountType"
          clearable
          filterable
          collapse-tags
          style="width: 170px"
          :show-all-levels="false"
          :props="{ multiple: true }"
          :options="HAS_AMOUNT_TYPES"
        >
          <template slot-scope="{ node, data }">
            <img v-if="node.level > 1" style="width: 15px" :src="`/images/lib/${data.imagePrefix}.png`" alt="" />
            <span>&ensp;{{ data.label }} </span>
          </template>
        </el-cascader>
      </ElFormItem>

      <ElFormItem label="使用情况">
        <el-cascader
          ref="hasPlanRef"
          v-model="formFields.planType"
          clearable
          filterable
          collapse-tags
          style="width: 170px"
          :show-all-levels="false"
          :props="{ multiple: true }"
          :options="HAS_PLAN_TYPES"
        >
          <template slot-scope="{ node, data }">
            <img v-if="node.level > 1" style="width: 15px" :src="`/images/lib/${data.imagePrefix}.png`" alt="" />
            <span>&ensp;{{ data.label }} </span>
          </template>
        </el-cascader>
      </ElFormItem>

      <ElFormItem label="媒体拒审">
        <SingleChildSelectTree v-model="formFields.mediaRejection" :options="MEDIA_REJECTIONS"></SingleChildSelectTree>
      </ElFormItem>

      <ElFormItem label="排序">
        <ElSelect v-model="formFields.sortType" style="width: 160px" @change="sendEvent">
          <ElOption v-for="item in SORT_TYPE_LIST" :value="item.id" :key="item.id" :label="item.name"></ElOption>
        </ElSelect>
      </ElFormItem>

      <ElFormItem label="上传时间">
        <DateRangePicker v-model="formFields.datetime" style="width: 220px" @change="sendEvent"></DateRangePicker>
      </ElFormItem>

      <ElFormItem class="bg-transparent">
        <slot></slot>
        <ElButton type="primary" @click="$router.push({ name: 'uploadingIndex' })">素材上传</ElButton>
      </ElFormItem>
    </ElForm>

    <Modal :visible.sync="scriptMatchModalVisible" title="结构化脚本搜索" @cancel="onScriptMatchModalClose">
      <el-form :model="scriptMatchForm" label-width="80px">
        <el-form-item label="视觉描述">
          <el-input
            type="textarea"
            v-model="scriptMatchForm.visual_core"
            placeholder="示例：一个男人孤独地走在雨夜的霓虹街道上"
            :rows="3"
          ></el-input>
        </el-form-item>

        <el-form-item label="叙事重点">
          <el-input
            type="textarea"
            v-model="scriptMatchForm.content_narrative_focus"
            placeholder="示例：强调人物的背影和地上的倒影"
            :rows="3"
          ></el-input>
        </el-form-item>

        <el-form-item label="情感氛围">
          <el-input type="textarea" v-model="scriptMatchForm.emotion_atmosphere" placeholder="示例：孤独、忧郁、思考" :rows="2"></el-input>
        </el-form-item>

        <el-form-item label="关键元素">
          <el-input
            type="textarea"
            v-model="scriptMatchForm.key_elements"
            placeholder="示例：雨夜, 城市, 霓虹, 背影, 倒影"
            :rows="2"
          ></el-input>
          <p>提示：多个关键词请用”,“分割</p>
        </el-form-item>
      </el-form>

      <template #confirm-btn>
        <el-button type="primary" :loading="scriptMatchLoading" @click="onScriptMatchConfirm()">搜 索</el-button>
      </template>
    </Modal>
  </div>
</template>
<script setup>
import { ref, reactive, computed, onActivated, onMounted, shallowRef } from 'vue'
import { Message } from 'view-design'
import { useRoute, useRouter } from 'vue-router/composables'
import { isArray, trim, getBinaryValue } from '@/common/js/utils'
import dimension_data from '../../data/dimension_data'
import promote_media from '../../data/promote_media'
import size_data from '../../data/size_data'
import toutiao_label from '../../data/toutiao_label'
import {
  SEARCH_LABEL_LIST,
  SEARCH_TYPE,
  REJECT_REASONS,
  SORT_TYPE_LIST,
  HAS_AMOUNT_TYPES,
  HAS_PLAN_TYPES,
  MEDIA_REJECTIONS,
  LIB_FILTER_VALUE
} from '../const.js'
import { LABEL_TYPES, LEVEL_TYPES, SOURCE_TYPES } from '../../tags/const'
import DateRangePicker from '@/components/date-range-picker'
import ThrottleSelector from '@/components/throttle-select/index.vue'
import Modal from '@/views/create/gdt/components/distribute/components/modal.vue'
import SingleChildSelectTree from './single-child-select-tree.vue'
import { getSysTagByTree, getGameGroupTree, queryAllMetaSources } from '@/api/common.model.js'
import { tagTreeLoop } from '@/views/material/tags/hooks/useTags.js'
import { initPageData, SYS_USERS, SYS_TAGS, SYS_TAG_GROUPS, AI_TAG_TREE, IMAGE_STYLE_TAG_TREE } from '@/data/global-opts'
import { MEDIAS } from '@/common/js/constants'

// Emits
// eslint-disable-next-line
const emit = defineEmits(['on-change'])

// Composables
const route = useRoute()
const router = useRouter()
const searchInputRef = ref(null)
const hasAmountRef = ref(null)
const hasPlanRef = ref(null)
const mediaRejectionRef = ref(null)

// Global data from store
const PAGE_REQUIRED_OPTS = initPageData([SYS_USERS, SYS_TAGS, SYS_TAG_GROUPS, AI_TAG_TREE, IMAGE_STYLE_TAG_TREE])

const sysUsers = computed(PAGE_REQUIRED_OPTS.SYS_USERS)
const sysTags = computed(PAGE_REQUIRED_OPTS.SYS_TAGS)
const sysTagGroups = computed(PAGE_REQUIRED_OPTS.SYS_TAG_GROUPS)
const aiLabelList = computed(PAGE_REQUIRED_OPTS.AI_TAG_TREE)
const imageStyleTagList = computed(PAGE_REQUIRED_OPTS.IMAGE_STYLE_TAG_TREE)

const getScriptMatchForm = () => {
  return {
    visual_core: '',
    content_narrative_focus: '',
    emotion_atmosphere: '',
    key_elements: ''
  }
}

// Form fields reactive object
const formFields = reactive({
  sortType: 1,
  keyword: '',
  searchType: '',
  source: '',
  datetime: [],
  gameIds: [],
  aiLabelIds: [],
  designerIds: [],
  plannerIds: [],
  labelIds: [],
  typeLabelIds: [],
  selectGameList: [],
  mult_sizeRange: [],
  mult_dimension: [],
  mult_limit_media: [],
  videoLabelIds: [],
  originImageIdList: [],
  tagGroups: [],
  mult_image_styles: [],
  mult_toutiao_label: [],
  rejectReasonIds: [],
  shotInfo: {}, // 脚本结构化搜索
  similarSearch: false,
  amountType: [],
  planType: [],
  mediaRejection: []
})

// Other reactive refs
const gameCheckedNodes = ref([])
const aiLabelCheckedNodes = ref([])
const metaSources = shallowRef([])
const groupGames = shallowRef([])

// Template refs
const gameCascaderRef = ref(null)
const aiLabelCascaderRef = ref(null)

const scriptMatchModalVisible = ref(false)
const scriptMatchForm = ref(getScriptMatchForm())
const scriptMatchLoading = ref(false)
const showScriptMatchModal = () => {
  if (formFields.searchType === SEARCH_TYPE.SCRIPT) {
    scriptMatchModalVisible.value = true
    const [_, input] = searchInputRef.value.$el?.querySelectorAll('input') || []
    input && input.blur()
  }
}
// 找相似素材
const onScriptFindSimilar = (form) => {
  scriptMatchForm.value = form
  formFields.searchType = SEARCH_TYPE.SCRIPT
  onScriptMatchConfirm(2)
}
const onScriptMatchConfirm = (task_type = 1) => {
  const { visual_core, content_narrative_focus, emotion_atmosphere, key_elements } = scriptMatchForm.value
  formFields.shotInfo = {
    task_type, // 1 脚本结构化搜索 2 相似视频搜索
    segment: scriptMatchForm.value
  }

  const strList = Object.values(scriptMatchForm.value)
    .map((i) => trim(i))
    .filter((i) => i)

  if (!strList.length) return Message.error('请输入要检索素材片段的脚本内容')

  formFields.keyword = `视觉描述:${visual_core};叙事重点:${content_narrative_focus};情感氛围:${emotion_atmosphere};关键元素:${key_elements}`
  sendEvent()
  onScriptMatchModalClose()
}
const onScriptMatchModalClose = () => {
  scriptMatchModalVisible.value = false
}
const clearSearchInput = () => {
  // 如果没有脚本搜索内容，切换到全部搜索
  if (formFields.searchType === SEARCH_TYPE.SCRIPT) {
    formFields.shotInfo = {}
  }
}

const onSearchTypeChange = (val) => {
  formFields.keyword = ''

  if (val !== SEARCH_TYPE.SCRIPT) {
    scriptMatchForm.value = getScriptMatchForm()
  }
}

const searchBoxPlaceholder = computed(() => {
  switch (formFields.searchType) {
    case SEARCH_TYPE.ID:
      return '请输入素材ID'
    case SEARCH_TYPE.NAME:
      return '请输入素材名称'
    case SEARCH_TYPE.AI:
      return '请输入AI关键词'
    case SEARCH_TYPE.VIDEO:
      return '请输入视频描述'
    default:
      return '名称/ID/视频描述/片段描述'
  }
})

const labelList = computed(() => {
  return {
    contentLabels: sysTags.value.filter((i) => i.labelType === LABEL_TYPES.CONTENT_LABEL),
    threeDLabels: sysTags.value.filter((i) => i.labelType === LABEL_TYPES.THREED_LABEL)
  }
})

const sizeRangeArray = computed(() => {
  return size_data.filter((size) => formFields.mult_sizeRange.includes(size.key)).map((size) => size.value)
})

const dimensionsArray = computed(() => {
  return dimension_data.filter((dim) => formFields.mult_dimension.includes(dim.key)).map((dim) => dim.value)
})

const limitMediaArray = computed(() => {
  return promote_media.filter((media) => formFields.mult_limit_media.includes(media.key)).map((media) => media.value)
})

// Methods
const sendEvent = () => {
  emit('on-change')
}

const buildParams = () => {
  const [beginTime, endTime] = formFields.datetime || []
  const { orderColumn = 'create_time' } = SORT_TYPE_LIST.find((ret) => ret.id === formFields.sortType) || {}
  const { orderSort = 'desc' } = SORT_TYPE_LIST.find((ret) => ret.id === formFields.sortType) || {}

  const processedAiLabelIds = formFields.aiLabelIds.map((i) => i.slice(-1)).flat()
  const imageStyleIds = formFields.mult_image_styles.map((i) => i.slice(-1)).flat()

  const { mediaRejection, amountType, planType } = formFields
  const consumeStates = getBinaryValue(amountType)
  const planStates = getBinaryValue(planType)
  const mediaRejectionObj = {}
  for (const i in mediaRejection) {
    const { platform, rejectCount } = mediaRejection[i]
    if (platform === MEDIAS.TOUTIAO) mediaRejectionObj.toutiaoRejectCount = rejectCount
    if (platform === MEDIAS.GDT) mediaRejectionObj.gdtRejectCount = rejectCount
    if (platform === MEDIAS.KUAISHOU) mediaRejectionObj.kuaishouRejectCount = rejectCount
  }
  const params = {
    beginTime,
    endTime,
    orderColumn,
    orderSort,
    // 媒体有消耗，无消耗
    hasAmountType: consumeStates[LIB_FILTER_VALUE.CONSUMED],
    noAmountType: consumeStates[LIB_FILTER_VALUE.UN_CONSUMED],
    createPlanType: planStates[LIB_FILTER_VALUE.USED],
    noPlanType: planStates[LIB_FILTER_VALUE.UN_USED],
    // 媒体拒审次数
    ...mediaRejectionObj,

    sortType: formFields.sortType,
    keyword: trim(formFields.keyword),
    designerIds: formFields.designerIds,
    plannerIds: formFields.plannerIds,
    labelIds: [formFields.labelIds, formFields.videoLabelIds, formFields.typeLabelIds, processedAiLabelIds]
      .filter((i) => Array.isArray(i))
      .flat(),
    sizeRangeArray: sizeRangeArray.value,
    dimensionsArray: dimensionsArray.value,
    exludeMediaIds: limitMediaArray.value,
    tagGroups: formFields.tagGroups,
    originImageIdList: formFields.originImageIdList,
    gameIds: formFields.gameIds.map((arr) => arr.slice(-1)).flat(),
    searchType: formFields.searchType,
    imageStyleList: imageStyleIds,
    toutiaoLabel: formFields.mult_toutiao_label.reduce((sum, cVal) => sum + Number(cVal), 0),
    rejectReasonIds: formFields.rejectReasonIds.join(','),
    source: formFields.source,
    similarSearch: false
  }

  if (formFields.searchType === SEARCH_TYPE.SCRIPT) {
    if (!Object.keys(formFields.shotInfo).length) {
      formFields.searchType = SEARCH_TYPE.ALL
      params.searchType = SEARCH_TYPE.ALL
    } else {
      params.shotInfo = { ...formFields.shotInfo }
      params.similarSearch = formFields.shotInfo.task_type === 2
    }
  }
  return params
}

const onCascaderChange = (vals, checkedNodes, prop, showAllLevel = false) => {
  const leafNodes = showAllLevel ? checkedNodes : checkedNodes.filter((item) => !item.hasChildren)

  if (prop === 'gameCheckedNodes') {
    gameCheckedNodes.value = leafNodes.map((n) => n.label)
  } else if (prop === 'aiLabelCheckedNodes') {
    aiLabelCheckedNodes.value = leafNodes.map((n) => n.label)
  }
}

const openVideoCutPage = () => {
  window.open('/creatives/editor', '_blank')
}

const preload = () => {
  Promise.all([getGameGroupTree(), queryAllMetaSources()]).then((data) => {
    const [groupData, metaSourcesData] = data

    if (isArray(metaSourcesData)) {
      metaSources.value = metaSourcesData.map((i) => ({ imageId: i.imageId, imageName: i.imageName }))
    }

    if (isArray(groupData)) {
      groupGames.value = groupData.map((ret) => {
        return { gameId: ret.gameGroupId, gameName: ret.gameGroupName, children: ret.children }
      })
    }
  })
}

// Lifecycle hooks
onActivated(() => {
  const { queryType, queryStr } = route.query
  // src/views/material/tags/TagsKeyword.vue 关键词列表查看素材跳转
  if (queryType && queryStr) {
    formFields.searchType = queryType
    formFields.keyword = decodeURIComponent(queryStr)
    sendEvent()
    router.replace({ name: 'librarymain' })
  }
})

onMounted(() => {
  preload()
})

// Expose methods for parent component access
// eslint-disable-next-line
defineExpose({
  buildParams,
  onScriptFindSimilar
})
</script>
